import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ProductPricingsDetail } from "../../../components/Pages/Documents/ProductPricings/ProductPricingsDetail";
import { CreateProductPricingsDto } from "../../../dtos/documents/ProductPricings/CreateProductPricingsDto";
import { SalaryAccrualsDetail } from "../../../components/Pages/Documents/SalaryAccruals/SalaryAccrualsDetail";
import { CreateSalaryAccrualsDto } from "../../../dtos/documents/SalaryAccruals/CreateSalaryAccrualsDto";
import { SalaryAccrualsService } from "../../../services/documents/SalaryAccrualsService";
import { NFLookupSalaryAccruals } from "../../../components/Shared/NewForms/NFLookupSalaryAccruals";
import SalaryAccrualsList from "../../../components/Pages/Documents/SalaryAccruals/SalaryAccrualsList";

export const SalaryAccruals: IAppEntity = {
  entityType: "document",
  title: "Salary Accruals",
  pluralTitle: "Salary Accruals",
  apiUrl: "SalaryAccruals",
  apiEnum: ReferenceTypes.DocumentSalaryAccrual,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(SalaryAccrualsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(SalaryAccrualsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupSalaryAccruals, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new SalaryAccrualsService("SalaryAccruals"),
  getEmptyModel: () => {
    const model: CreateSalaryAccrualsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      month:new Date(),
      createdDate: new Date(),
      salaryAccrualEmployees: [],
      salaryAccrualAccruals:[],
      salaryAccrualDeductions:[]
    };
    return model;
  },
};
